module.exports = __webpack_public_path__ + "img/statics.1b5286ad.png";